// extracted by mini-css-extract-plugin
export default {"Warning":"EducationExpenseStatus_Warning__nxTcy"};